var DELTA_PERCENT = 1.7;
var getBottomBorderPosition = function getBottomBorderPosition(scrollHeight, clientHeight) {
  return scrollHeight - clientHeight * DELTA_PERCENT;
};
var shouldLoadMoreOptions = function shouldLoadMoreOptions(_ref) {
  var scrollTop = _ref.scrollTop,
    scrollHeight = _ref.scrollHeight,
    clientHeight = _ref.clientHeight;
  var bottomBorderPos = getBottomBorderPosition(scrollHeight, clientHeight);
  return scrollTop > bottomBorderPos;
};
export default shouldLoadMoreOptions;